import {
  arbitrum,
  base,
  baseSepolia,
  mainnet,
  optimism,
  sepolia,
  zora,
  zoraSepolia,
} from '@ourzora/chains'
import { cleanAddress } from '../../addresses'
import abi from './abi'

// https://docs.uniswap.org/contracts/v3/reference/deployments/

/**
 * UniswapV3SwapRouter contract address
 *
 * NOTE: This is the `SwapRouter02` contract address
 */
export const UniswapV3SwapRouter = {
  abi,
  address: {
    [mainnet.id]: cleanAddress('0x68b3465833fb72A70ecDF485E0e4C7bD8665Fc45'),
    [sepolia.id]: cleanAddress('0x3bFA4769FB09eefC5a80d6E87c3B9C650f7Ae48E'),
    [zora.id]: cleanAddress('0x7De04c96BE5159c3b5CeffC82aa176dc81281557'),
    [zoraSepolia.id]: cleanAddress('0x6B36d761981d82B1e07cF3c4daF4cB4615c4850a'),
    [base.id]: cleanAddress('0x2626664c2603336E57B271c5C0b26F421741e481'),
    [baseSepolia.id]: cleanAddress('0x94cC0AaC535CCDB3C01d6787D6413C739ae12bc4'),
    [optimism.id]: cleanAddress('0x68b3465833fb72A70ecDF485E0e4C7bD8665Fc45'),
    [arbitrum.id]: cleanAddress('0x68b3465833fb72A70ecDF485E0e4C7bD8665Fc45'),
  } as const,
} as const
